import React, { useEffect, useRef, useState } from 'react';
import { Text, DefaultButton, IPanelStyles, ITextStyles, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton, IDropdownOption } from '@fluentui/react';

import { IChoiceField, IField, IForwardRule, ITextField, IRuoloUor, ITitolario, IUor, IUser, IUserField, IAutocompleteField } from '../../shared/interfaces';
import DynamicForm from '../DynamicForm/DynamicForm';
import { useBoolean } from '@fluentui/react-hooks';
import rolesService from '../../services/roles.service';
import { RootState } from '../../store';
import { connect, ConnectedProps, useSelector } from 'react-redux';
import { Indici_FormMode, RoleContext, Visibility_Type, Visibility_Type_Label } from '../../shared/enums';
import AppUtilities from '../../shared/Utilities/appUtilities';
import CircleLoader from '../Loader/CircleLoader/CircleLoader';
import uorsService from '../../services/uors.service';
import fieldsService from '../../services/fields.service';


const mapState = (state: RootState) => ({

})

const mapDispatch = {

}
const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface AddEditForwardRuleProps {
    loading?: boolean
    extraCssClass?: string
    selectedForwardRule?: Partial<IForwardRule>,
    panelHeaderText: string
    panelIsOpen: boolean
    targetFieldIsReadOnly?: boolean,
    onSubmit: (forwardRule: Partial<IForwardRule>[]) => void
    onDismiss: () => void

}

type Props = AddEditForwardRuleProps & PropsFromRedux

const AddEditForwardRule: React.FunctionComponent<Props> = (props) => {

    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);

    let loading = props.loading !== undefined ? props.loading : false;

    const [panelIsOpen, setPanelIsOpen] = useState<boolean>(props.panelIsOpen);
    const [messageBarIsVisible, { setTrue: showMessageBar, setFalse: dismissMessageBar }] = useBoolean(false);
    const [messageBarType, setMessageBarType] = useState<MessageBarType>();
    const [messageBarText, setMessageBarText] = useState<string>('');
    const [formFields, setFormFields] = useState<IField[]>([]);
    const [targetFieldOptions, setTargetFieldOptions] = useState<IDropdownOption[]>([]);
    const [uorOptions, setUorOptions] = useState<IDropdownOption[]>([]);
    const [selectedUor, setSelectedUor] = useState<IDropdownOption>();






    useEffect(() => {
        if (targetFieldOptions.length == 0) {
            getTargetFieldOptions();
        }

        if (uorOptions.length == 0) {
            getUorOptions();
        }




        //resetFields();

        dismissMessageBar();

        setPanelIsOpen(props.panelIsOpen)
    }, [props.panelIsOpen]);


    useEffect(() => {
        resetFields();
    }, [props.selectedForwardRule, targetFieldOptions, props.targetFieldIsReadOnly, uorOptions]);

    const getTargetFieldOptions = () => {
        if (currentAoo) {
            fieldsService.getFieldsByViewName(currentAoo.id, 'Campi protocollo')
                .then((fields) => {

                    let _fields = AppUtilities.fixFieldsForm(Indici_FormMode.CreateForwardRule, fields);
                    let options: IDropdownOption[] = _fields.map(el => { return { text: el.displayName, key: el.internalName, id: el.internalName, data: el } })

                    // settando TargetFieldOptions si attiva il relativo useEffect che reimposta i fields
                    // in questo modo aggiorno le options delle dropdown
                    setTargetFieldOptions(options);


                });
        }
    }


    const getUorOptions = () => {
        if (currentAoo) {
            uorsService.getOrganigrammaAoo(currentAoo.id)
                .then(uors => {
                    let organigrammaFlat: IDropdownOption[] = [];
                    /// Rimappo le uor nel formato IDropdownOption[] per utilizzarlo nella dropdown
                    remapOrganigrammaNodes(uors, organigrammaFlat);

                    // settando UorOptions si attiva il relativo useEffect che reimposta i fields
                    // in questo modo aggiorno le options delle dropdown
                    setUorOptions(organigrammaFlat);
                });
        }
    }

    const remapOrganigrammaNodes = (uorList, organigrammaFlat: IDropdownOption[]) => {
        uorList.forEach(uorItem => {
            organigrammaFlat.push({
                key: uorItem.id,
                id: uorItem.id,
                data: {
                    id: uorItem.id,
                    nome: uorItem.nome,
                    sigla: uorItem.sigla,
                },
                text: `${uorItem.sigla} - ${uorItem.nome}`
            });
            remapOrganigrammaNodes(uorItem.children, organigrammaFlat)

        });
    }

    const resetFields = () => {

        // se la selectedForwardRule ha già una uor significa che sono in modifica e quindi il
        // campo uor lo visulizzo con la selezione singola
        // se invece si tratta di un nuovo inserimento visualizzo il campo uor con la selezione multipla
        // e creo una nuova regola per ogni uor selezionata
        let uorDropdownIsMulti = props.selectedForwardRule && props.selectedForwardRule.uorId ? false : true;

        const formsInitialFields = [

            {
                displayName: "Campo",
                internalName: "fieldInternalName",
                controlType: "dropdown",
                required: true,
                readonly: props.targetFieldIsReadOnly,
                disabled: false,
                system: false,
                internalValue: props.selectedForwardRule && props.selectedForwardRule.fieldInternalName ? props.selectedForwardRule.fieldInternalName : '',
                valid: false,
                touched: false,
                multi: false,
                options: targetFieldOptions
            } as IChoiceField,
            {
                displayName: "Valore",
                internalName: "fieldInternalValue",
                controlType: "textbox",
                required: false,
                readonly: props.targetFieldIsReadOnly,
                disabled: false,
                system: false,
                internalValue: props.selectedForwardRule && props.selectedForwardRule.fieldInternalValue ? props.selectedForwardRule.fieldInternalValue : '',
                valid: false,
                touched: false,

            } as ITextField,
            {
                displayName: "UOR",
                internalName: "uor",
                controlType: "dropdown",
                required: true,
                readonly: false,
                disabled: false,
                system: false,
                internalValue: props.selectedForwardRule && props.selectedForwardRule.uorId ? props.selectedForwardRule.uorId : '',
                valid: false,
                touched: false,
                multi: uorDropdownIsMulti,
                options: uorOptions
            } as IChoiceField,
            {
                displayName: "Tipo visibilità",
                internalName: "visibilityType",
                controlType: "dropdown",
                required: true,
                readonly: false,
                disabled: false,
                system: false,
                internalValue: props.selectedForwardRule && props.selectedForwardRule.visibilityType ? props.selectedForwardRule.visibilityType : '',
                valid: false,
                touched: false,
                multi: false,
                options: [
                    { text: Visibility_Type_Label.get(Visibility_Type.CopiaConoscenza), key: Visibility_Type.CopiaConoscenza },
                    { text: Visibility_Type_Label.get(Visibility_Type.Inoltro), key: Visibility_Type.Inoltro },
                ] as IDropdownOption[]
            } as IChoiceField,

        ];




        setFormFields(formsInitialFields);

    }


    // Click su salva del panel laterale
    const addEditForwardRuleSubmit = () => {

        if (checkForwardRuleFormValidity()) {
            // se la selectedForwardRule ha già una uor significa che sono in modifica e quindi il
            // campo uor lo visulizzo con la selezione singola
            // se invece si tratta di un nuovo inserimento visualizzo il campo uor con la selezione multipla
            // e creo una nuova regola per ogni uor selezionata
            let uorDropdownIsMulti = props.selectedForwardRule && props.selectedForwardRule.uorId ? false : true;


            let _fieldInternalName = formFields.find(el => el.internalName === 'fieldInternalName')?.internalValue;
            let _fieldInternalValue = formFields.find(el => el.internalName === 'fieldInternalValue')?.internalValue;
            let _visibilityType = formFields.find(el => el.internalName === 'visibilityType')?.internalValue;

            let _uors: any[]
            if (uorDropdownIsMulti) {
                _uors = [...formFields.find(el => el.internalName === 'uor')?.internalValue];
            }
            else {
                _uors = [formFields.find(el => el.internalName === 'uor')?.internalValue];

            }

            let newForwardRules: Partial<IForwardRule>[] = [];
            _uors.forEach(uor => {
                newForwardRules.push({
                    id: props.selectedForwardRule && props.selectedForwardRule.id ? props.selectedForwardRule.id : undefined,
                    fieldInternalName: _fieldInternalName,
                    fieldInternalValue: _fieldInternalValue,
                    uorId: uor,
                    visibilityType: _visibilityType
                });
                props.onSubmit(newForwardRules);

            });
        }
    }

    const checkForwardRuleFormValidity = (): boolean => {

        let isValid = true;

        const updatedFields = AppUtilities.checkFormFieldsValidity(formFields);
        // la form è valida se non ci sono field non validi
        isValid = !updatedFields.find(el => !el.valid);

        setFormFields(updatedFields);
        if (isValid) {
            dismissMessageBar();
        }
        else {
            setMessageBarText('Compilare correttamente i campi');
            setMessageBarType(MessageBarType.error);
            showMessageBar();
        }

        return isValid;
    }


    const inputChangedHandler = (newField: IField) => {

        const updatedFields = [...formFields];
        let itemIndex = updatedFields.findIndex(el => el.internalName === newField.internalName);

        updatedFields[itemIndex] = { ...newField };

        setFormFields(updatedFields);
    }



    const onRenderLateralPanelFooterContent = () => {
        return (
            <React.Fragment>
                <PrimaryButton
                    styles={{ root: { marginRight: 8 } }}
                    text="Salva"
                    onClick={addEditForwardRuleSubmit}

                />
                <DefaultButton
                    onClick={props.onDismiss}
                    text="Annulla"
                />
            </React.Fragment>
        );
    }


    return (
        <React.Fragment>
            <Panel
                key='addEditUserPanel'
                isLightDismiss
                isOpen={panelIsOpen}
                type={PanelType.custom}
                customWidth={'600px'}
                headerText={props.panelHeaderText}
                focusTrapZoneProps={{
                    isClickableOutsideFocusTrap: true,
                    forceFocusInsideTrap: true,
                }}
                onDismiss={props.onDismiss}
                onRenderFooterContent={onRenderLateralPanelFooterContent}
                // Stretch panel content to fill the available height so the footer is positioned
                // at the bottom of the page
                isFooterAtBottom={false}
            >
                {messageBarIsVisible &&
                    <MessageBar
                        messageBarType={messageBarType}
                        isMultiline={false}
                        onDismiss={dismissMessageBar}
                        dismissButtonAriaLabel="Close">{messageBarText}</MessageBar>
                }

                <CircleLoader loaderClass='loader-large' loading={loading} />

                <div className={"flex flex-column position-relative overflow-hidden"}>

                    <div className={`position-relative my-scroll-div`}>

                        <DynamicForm
                            fields={formFields}
                            onInputChangedHandler={(newField) => { inputChangedHandler(newField) }}
                        />
                    </div>
                </div>


            </Panel>



        </React.Fragment>

    );
}

export default connector(AddEditForwardRule);
